"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _th_TH = _interopRequireDefault(require("../../date-picker/locale/th_TH"));
var _default = exports.default = _th_TH.default;